import { render, staticRenderFns } from "./informed-consent-detail.vue?vue&type=template&id=84d472b6&scoped=true&"
import script from "./informed-consent-detail.vue?vue&type=script&lang=js&"
export * from "./informed-consent-detail.vue?vue&type=script&lang=js&"
import style0 from "./informed-consent-detail.vue?vue&type=style&index=0&id=84d472b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d472b6",
  null
  
)

export default component.exports